  <template>
            <div v-if="showForm" class="popupContainer">
              <h4 class="font-weight-bold" style="float: left">
                {{title}}
              </h4>
              <div class="close-popup-container">
                <div @click="$emit('close')">
                  <span class="cursor-pointer ml-auto">
                  <i class="vs-icon notranslate icon-scale material-icons null">close</i>
                  </span>
                </div>
              </div>
              <div style="margin-top:40px !important;" class="vs-component vs-divider"><span class="vs-divider-border after vs-divider-border-default" style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1);"></span><!----><span class="vs-divider-border before vs-divider-border-default" style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1);"></span></div>
              <div v-if="!loading" class="vs-scrollable" style="width:100%;line-height: 2.45;">
                <div>
                  <div class="con-exemple-customer-prompt px-4 py-3">
                    <vs-row>
                      <h3><br>{{$t('Service.Table.Title')}} </h3>
                    </vs-row>
                    <vs-row>
                    <vs-input
                          label="en"
                          class="w-100 mb-2"
                          v-model="paymentMethod.translations.en"
                        />
                    </vs-row>
                    <vs-row>
                    <vs-input
                          label="fr"
                          class="w-100 mb-2"
                          v-model="paymentMethod.translations.fr"
                        />
                    </vs-row>

                    <vs-row>
                        <vs-input
                            label="ar"
                            class="w-100 mb-2"
                            v-model="paymentMethod.translations.ar"
                            />
                    </vs-row>

                    <vs-row>
                        <vs-input
                            label="de"
                            class="w-100 mb-2"
                            v-model="paymentMethod.translations.de"
                            />
                    </vs-row>

                    <vs-row>
                        <vs-input
                            label="es"
                            class="w-100 mb-2"
                            v-model="paymentMethod.translations.es"
                            />
                    </vs-row>


                    <vs-col vs-w="12" class="text-right mt-4">
                        <vs-button color="primary" @click="validate" class="pr-5 pl-5 float-right"> {{$t('Customer.EditCustomerPrompt.ConfirmButton')}} </vs-button>
                    </vs-col>
                  </div>
                </div>
              </div>

            </div>
</template>

<script>
import {paymentMethodsService} from "../../_services";
export default {
    name:"paymentMethodFrom",
    data: () => ({
      translations:{fr:'',en:'',ar:'',de:null,es:null},
      paymentMethod: {},
      loading:true,
    }),
    props:{
        showForm: {required: false, type:Boolean},
        title : {required: false, type:String},
        pm: {required: false, type:Object},
    },
    emits: ['close', 'updated', 'created'],
    methods:{
        validate() {
          if(!this.paymentMethod.translations.en.length || !this.paymentMethod.translations.ar.length || !this.paymentMethod.translations.fr.length) {
            this.notify(
                "Error",
                "Arabic, french ,english fields required",
                "danger"
            );
            return;
          }
          this.showLoading();
          if(this.pm) {
            this.updatePm();
          } else {
            this.addPm();
          }
        },

          updatePm() {
          const payload = {title: JSON.stringify(this.paymentMethod.translations)};
          paymentMethodsService
              .updateType(payload, this.pm.id)
              .then((res)=>{
                this.notify(
                    this.$t("Toasts.Successful"),
                    "Updated successfully",
                    "success"
                );
                this.hideLoading();
                this.$emit('updated', res.data);
              })
              .catch(()=>{
                console.log(err);
                this.notify(
                    "Error",
                    "Unkown error",
                    "danger"
                );
                this.hideLoading();
              })
        },
        addPm() {
          const payload = {title: JSON.stringify(this.paymentMethod.translations)};
        paymentMethodsService
            .addType(payload)
            .then((res)=>{
              this.notify(
                  this.$t("Toasts.Successful"),
                  "Added successfully",
                  "success"
              );
              this.hideLoading();
              this.$emit('created', res.data);
            })
            .catch(()=>{
              console.log(err);
              this.notify(
                  "Error",
                  "Unkown error",
                  "danger"
              );
              this.hideLoading();
            })
        },
          notify(title, text, type) {
            this.$vs.notify({
              color: type,
              title: title,
              text: text
            });
          },
        showLoading() {
        this.$vs.loading({
            container: "#customers-box",
            scale: 0.6
        });
        },
        hideLoading(){
      this.$vs.loading.close('#customers-box > .con-vs-loading')
    },

    },
    created() {
      this.loading = true;
      if(this.pm) {
        this.paymentMethod = this.pm;
        this.paymentMethod.translations = JSON.parse(this.pm.translations);
        this.loading = false;
      } else {
        this.paymentMethod.title = "";
        this.paymentMethod.translations = this.translations;
        this.loading = false;
      }
      console.log(this.paymentMethod);
    }
}
</script>

<style scoped>
  .popupContainer{
    height: 100vh;
    width: 50%;
    padding: 40px;
    position: absolute;
    right: 0 !important;
    top: 0 !important;
    z-index: 99999;
    background: #FFFFFF;
  }

  .close-popup-container{
    float: right !important;
  }
  .close-popup {
    font-family: 'Exo 2', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 6.5vmin;
    line-height: 7vmin;
    cursor:pointer;
    /* Gray Light */
    color: #E3E3E3;
  }

</style>
